/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Changed_MindInputs */

const cs_enum_changed_mind = /** @type {(inputs: Enum_Changed_MindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna názoru`)
};

const en_enum_changed_mind = /** @type {(inputs: Enum_Changed_MindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed mind`)
};

/**
* | output |
* | --- |
* | "Changed mind" |
*
* @param {Enum_Changed_MindInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_changed_mind = /** @type {((inputs?: Enum_Changed_MindInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Changed_MindInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_changed_mind(inputs)
	return cs_enum_changed_mind(inputs)
});